import type { FC } from 'react';
import classNames from 'classnames';
import styles from './PasswordRequirements.module.scss';
import CheckIcon from './check.svg?react';
import CrossIcon from './cross.svg?react';
import { passwordRequirements } from '@/shared/utils';

interface Props {
  /** The current password value; each requirement is tested against it live. */
  value: string;
}

/**
 * Live checklist of the new-password policy rules. Each rule shows a green checkmark when met and a
 * red cross when not, updating as the user types. Rules come from the shared policy via
 * `passwordRequirements`.
 */
export const PasswordRequirements: FC<Props> = ({ value }) => (
  <ul className={styles.list} data-testid="password-requirements">
    {passwordRequirements.map(({ label, test }) => {
      const met = test(value);

      return (
        <li key={label} className={classNames(styles.item, met ? styles.item_met : styles.item_unmet)}>
          {met ? <CheckIcon className={styles.icon} /> : <CrossIcon className={styles.icon} />}
          <span>{label}</span>
        </li>
      );
    })}
  </ul>
);
